module.exports = __webpack_public_path__ + "img/loader-white.0f8c4217.svg";